import React from 'react';
import { filter, head, path, pipe, prop, sort } from 'ramda';
import { Link } from 'js/components/common/Link';
import { numberPredicate } from 'js/utils/predicate.util';
import DepositMethodFactory from '../Deposit/DepositMethodFactory';
import { useAppSelector } from 'js/store/hooks';
import { fetch, useParams } from '../withCashierPortlet';
import { INITIATORS, CREDIT_CARD, NUVEI_REDIRECT_TYPE } from '../constants';
import Empty from './Empty';
import { usePortletSelector, usePortletTranslations, withPortlet } from 'js/components/system/Portlet';
import reducer, { initialState } from '../reducer';
import { pickPaths } from 'js/utils/methods.util';

import style from './index.scss';
import cashierStyle from '../index.scss';

export const getAccountTime = pipe(
    path(['accounts', '0', 'lastDepositTime']),
    x => new Date(x).getTime()
);

export const QuickDepositBare = (props) => {
    const t = usePortletTranslations();
    const {
        code,
        title,
        isEmpty
    } = usePortletSelector(pickPaths([
        ['method', 'code'],
        ['accounts', 0, 'title'],
        ['isEmpty']
    ]));
    const depositPage = useAppSelector(prop('depositPage'));

    if (isEmpty) {
        return <Empty />;
    }

    return (
        <div className={`${style.container} cms-quick-deposit`}>
            <div className={style.header}>
                <figure className={cashierStyle.logoHolder}>
                    <div aria-label={t('payment-method')} className={`${cashierStyle.logo} ${cashierStyle[`logo_${code}`]}`} role="img"/>
                    <figcaption className={cashierStyle.logoCaption}>{title}</figcaption>
                </figure>
                <div className={style.anotherPMLinkHolder}>
                    <Link href={depositPage}>{t('link.selectAnotherPM')}</Link>
                </div>
            </div>
            <div className={style.body}>
                <DepositMethodFactory {...props} />
            </div>
        </div>
    );
};

const parseQdOnResponse = (collection) => {
    const lastDepositMethod = pipe(
        filter(path(['accounts', '0', 'lastDepositTime'])),
        sort(numberPredicate(false, getAccountTime)),
        head
    )(collection);

    if (!lastDepositMethod) {
        return {
            isEmpty: true,
            haveNotDeposited: true
        };
    }

    const { reDirectType, depositType } = lastDepositMethod;

    if (depositType === CREDIT_CARD && reDirectType === NUVEI_REDIRECT_TYPE) {
        return {
            isEmpty: true,
            lastMethodDoesntSupportQd: true
        };
    }

    const { quickDeposit, accounts: [lastDepositAccount] } = lastDepositMethod;

    if (!quickDeposit) {
        return {
            isEmpty: true,
            lastMethodDoesntSupportQd: true
        };
    }

    return {
        method: lastDepositMethod,
        accounts: [lastDepositAccount],
        isQuickDeposit: true
    };
};

const Error = ({ message: { data } }) => {
    const { isEmpty } = data;
    if (isEmpty) {
        return <Empty />;
    }
};

const onError = (errorResponse) => {
    const { data: { errorCode, errorDescription } = {} } = errorResponse;

    if (errorCode === 1014) {
        return {
            data: {
                isEmpty: true,
                description: errorDescription
            }
        };
    }

    throw errorResponse;
};

export const parseCms = config => ({
    ...config,
    tkPrefix: 'playtech.mobile.system.mobile-cashier.',
    cashierType: 'deposit',
    paymentType: 'deposit', // cashierType.toLowerCase()
    initiator: INITIATORS.CASHIER_QD
});

export const withQuickDeposit = withPortlet({
    forLoggedIn: true,
    parseCms,
    reducer,
    initialState,
    fetch,
    useParams,
    onResponse: parseQdOnResponse,
    onError,
    Error,
    name: 'QuickDeposit'
});

export const QuickDeposit = withQuickDeposit(QuickDepositBare);

export default QuickDeposit;
